import React from 'react';
import VStack from '../Layout/VStack';
import AppText from '../AppText';
import {Colors} from '../../../styles/Colors';
import {GlobalStyleAttributes} from '../../../styles/GlobalStyles';

const SectionSeparator = ({title}) => (
    <VStack style={{paddingBottom: '0.5rem', borderBottom: `1px solid ${Colors.borderColor}`}}>
        <AppText boldFont fontSize={GlobalStyleAttributes.fonts.heading18}>{title}</AppText>
    </VStack>
);

export default SectionSeparator;
